import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';
// utils
import axios, { fetcher, endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

export function useGetDashboardImpressions() {
    const URL = endpoints.dashboard.list;

    const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
    const response = data?.data;
    const memoizedValue = useMemo(
        () => ({
            dashboard: response || [],
            dashboardLoading: isLoading,
            dashboardError: error,
            dashboardValidating: isValidating,
            dashboardEmpty: !isLoading && !response?.users?.length,
        }),
        [response, error, isLoading, isValidating]
    );

    return memoizedValue;
}

export function useGetLogs() {
    const URL = endpoints.dashboard.logs;

    const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
    const response = data;
    const memoizedValue = useMemo(
        () => ({
            logs: response || [],
            logsLoading: isLoading,
            logsError: error,
            logsValidating: isValidating,
            // logsEmpty: !isLoading && !response?.users?.length,
        }),
        [response, error, isLoading, isValidating]
    );

    return memoizedValue;
}
export function useGetHeatMap() {
    const URL = endpoints.dashboard.heatmap;

    const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
    const response = data;
    const memoizedValue = useMemo(
        () => ({
            heatMap: response || [],
            heatMapLoading: isLoading,
            heatMapError: error,
            heatMapValidating: isValidating,
            // logsEmpty: !isLoading && !response?.users?.length,
        }),
        [response, error, isLoading, isValidating]
    );

    return memoizedValue;
}

export async function GetHeatMap(apiData) {
    const URL = endpoints.dashboard.heatmap;

    try {
      const { data } = await axios.post(endpoints.dashboard.heatmap, apiData || {});
      const response = data;
      return response;
    } catch {
    //   (error) => {
    //     console.error(error);
    //   };
    }
  }

  export function useGetDashboardStats(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    const formatted = `${day}-${month}-${year}`;
    const URL = `${endpoints.stats.list}${formatted}`;

    const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
    const response = data?.data;
    const memoizedValue = useMemo(
        () => ({
            dashboard: response || [],
            dashboardLoading: isLoading,
            dashboardError: error,
            dashboardValidating: isValidating,
            dashboardEmpty: !isLoading && !response?.users?.length,
        }),
        [response, error, isLoading, isValidating]
    );

    return memoizedValue;
}

  export function useGetDashboardRecentActivity(date) {

    const day = String(date?.getDate()).padStart(2, '0');
    const month = String(date?.getMonth() + 1).padStart(2, '0');
    const year = date?.getFullYear();

    const formatted = `${day}-${month}-${year}`;

    const URL = `${endpoints.stats.recentActivity}${date ? `/?date=${formatted}` : ''}`;

    const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
    const response = data?.data;
    const memoizedValue = useMemo(
        () => ({
            activity: response || [],
            activityLoading: isLoading,
            activityError: error,
            activityValidating: isValidating,
            activityEmpty: !isLoading && !response?.users?.length,
        }),
        [response, error, isLoading, isValidating]
    );

    return memoizedValue;
}


export function useGetDashboardReminder(date) {

    const day = String(date?.getDate()).padStart(2, '0');
    const month = String(date?.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date?.getFullYear();

    const formatted = `${day}-${month}-${year}`;

    const URL = `${endpoints.stats.goBackReminder}${date ? `/?date=${formatted}` : ''}`;

    const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });
    const response = data?.data;
    const memoizedValue = useMemo(
        () => ({
            reminders: response?.reminders?.reverse() || [],
            remindersLoading: isLoading,
            remindersError: error,
            remindersValidating: isValidating,
            remindersEmpty: !isLoading && !response?.users?.length,
        }),
        [response?.reminders, error, isLoading, isValidating]
    );

    return memoizedValue;
}


export function useGetDashboardGraph(userId, timeFrame) {

  const URL = `${endpoints.dashboard.timeSpent}/${userId}${timeFrame ? `?timeFrame=${timeFrame}` : ''}`;

    const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    });
    const response = data?.data;
    const memoizedValue = useMemo(
      () => ({
        graph: response || [],
        graphLoading: isLoading,
        graphError: error,
        graphValidating: isValidating,
        graphEmpty: !isLoading && !response?.users?.length,
      }),
      [response, error, isLoading, isValidating]
    );

    return memoizedValue;
  }


export function useGetTimeSpent(userId, timeFrame) {

  const URL = `${endpoints.dashboard.timeSpent}/${userId}${timeFrame ? `?timeframe=${timeFrame}` : ''}`;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      timeSpent: response || [],
      timeSpentLoading: isLoading,
      timeSpentError: error,
      timeSpentValidating: isValidating,
      timeSpentEmpty: !isLoading && !response?.users?.length,
    }),
    [response, error, isLoading, isValidating]
  );

  return memoizedValue;
}
